var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetworkLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1568,
    height: 1026,
    viewBox: "0 0 1568 1026",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51994 1C59.9111 293.512 94.6172 434.191 380.6 495.123",
    stroke: "#2D76EB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51994 268.164C58.1383 520.979 284.611 506.223 373.874 506.223",
    stroke: "#7CAFFF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51994 1025.18C59.9071 732.67 95.4537 591.084 381.417 530.152",
    stroke: "#2055AA",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51994 756.605C58.1383 503.79 284.611 518.545 373.873 518.545",
    stroke: "#7CF7FF",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 520.762,
    y1: 510.333,
    x2: 1567.87,
    y2: 510.333,
    stroke: "url(#paint0_linear_14_15)",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 518.644,
    y1: 504.96,
    x2: 1567.87,
    y2: 504.961,
    stroke: "url(#paint1_linear_14_15)",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 520.762,
    y1: 515.705,
    x2: 1567.87,
    y2: 515.705,
    stroke: "url(#paint2_linear_14_15)",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 518.644,
    y1: 521.077,
    x2: 1567.87,
    y2: 521.077,
    stroke: "url(#paint3_linear_14_15)",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M437.103 567.274L436.408 567.148L436.058 567.761L430.683 577.142L430.68 577.148C428.971 580.178 425.298 581.462 421.99 580.245C414.361 577.396 407.379 573.329 401.232 568.219L401.23 568.217C398.591 566.037 397.898 562.179 399.628 559.192L399.63 559.188L405.004 549.806L405.356 549.192L404.893 548.656C400.449 543.507 396.973 537.517 394.645 531.001L394.408 530.338H393.704H382.881C379.428 530.338 376.44 527.863 375.871 524.416L375.871 524.413C374.572 516.653 374.511 508.509 375.871 500.415L375.871 500.412C376.441 496.961 379.439 494.434 382.881 494.434H393.704H394.409L394.645 493.77C396.967 487.256 400.448 481.266 404.893 476.116L405.356 475.58L405.004 474.966L399.63 465.584L399.628 465.582C397.897 462.582 398.54 458.732 401.222 456.562L401.222 456.562L401.232 456.554C407.377 451.451 414.428 447.37 421.993 444.52C425.293 443.306 428.966 444.588 430.681 447.619L430.683 447.624L436.058 457.005L436.409 457.619L437.105 457.492C443.875 456.258 450.779 456.258 457.544 457.492L458.239 457.619L458.591 457.005L463.965 447.624L463.967 447.619C465.683 444.587 469.351 443.305 472.651 444.521C480.292 447.363 487.268 451.442 493.41 456.553L493.413 456.556C496.051 458.735 496.744 462.593 495.014 465.58L495.012 465.584L489.638 474.966L489.286 475.58L489.749 476.116C494.194 481.266 497.669 487.255 499.99 493.77L500.227 494.434H500.932H511.755C515.207 494.434 518.191 496.909 518.765 500.352L518.765 500.353C520.064 508.119 520.125 516.263 518.765 524.357L518.765 524.358C518.189 527.813 515.196 530.338 511.755 530.338H500.932H500.227L499.991 531.002C497.669 537.511 494.193 543.507 489.749 548.656L489.286 549.192L489.638 549.806L495.012 559.188L495.014 559.192C496.75 562.19 496.103 566.04 493.42 568.21L493.42 568.21L493.41 568.219C487.271 573.327 480.221 577.396 472.649 580.246C469.352 581.466 465.684 580.18 463.967 577.147L463.965 577.142L458.591 567.761L458.239 567.147L457.544 567.274C450.835 568.495 443.869 568.496 437.103 567.274ZM429.25 530.302L429.329 530.406L429.433 530.485C442.447 540.497 456.519 538.127 464.806 529.841C473.093 521.555 475.466 507.482 465.461 494.464L465.382 494.361L465.279 494.281C452.258 484.238 438.182 486.608 429.894 494.902C421.608 503.196 419.238 517.285 429.25 530.302Z",
    stroke: "#08B248",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_15",
    x1: 893.509,
    y1: 511.333,
    x2: 1351.05,
    y2: 511.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08B248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CAFFF",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_15",
    x1: 1043.26,
    y1: 505.961,
    x2: 1347.6,
    y2: 505.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08B248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2055AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_15",
    x1: 570.546,
    y1: 517.706,
    x2: 1487.19,
    y2: 517.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08B248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EBFFF",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_15",
    x1: 762.925,
    y1: 522.077,
    x2: 1685.88,
    y2: 522.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08B248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FBFF",
    stopOpacity: 0.63
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkLines);
export default __webpack_public_path__ + "static/media/network-lines.942ce03c09e45731a5ee06b2597b1d1b.svg";
export { ForwardRef as ReactComponent };